import { EntityRepository, EntityWithDetails } from '~/repositories/EntityRepository';

import { createApiHook } from './utils/createApiHook';

export const useEntity = createApiHook<EntityWithDetails, GetRequestType>(EntityRepository.get);
